/**
 * Profile Service — hits AMC backend.
 *
 * Backend GET /api/users/me lazily upserts a user_profiles row from Entra
 * claims on first call, so no client-side seeding is needed.
 */

import { apiFetch } from './api';

function nameParts(me) {
  const first = me.firstName ?? '';
  const last = me.lastName ?? '';
  return { first, last };
}

export async function getCurrentProfile() {
  const me = await apiFetch('/api/users/me');
  const { first, last } = nameParts(me);
  return {
    id: me.id,
    firstName: first,
    lastName: last,
    email: me.email,
    role: me.isAdmin ? 'Admin' : 'User',
    departmentRoles: me.departmentRoles || {},
    description: me.description || '',
    avatarUrl: me.avatarUrl || null,
  };
}

export async function updateProfile(updates) {
  await apiFetch('/api/users/me', {
    method: 'PATCH',
    body: JSON.stringify({
      firstName: updates.firstName ?? null,
      lastName: updates.lastName ?? null,
      description: updates.description ?? null,
      avatarUrl: updates.avatarUrl ?? null,
    }),
  });
  return getCurrentProfile();
}
